import React, { ReactElement } from 'react';

import { connect, ConnectedProps } from 'react-redux';
import store, { RootState } from '../../../redux';

const mapState = (state: RootState) => {
  return state.auth;
}

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>

type AuthenticatedRouteProps = PropsFromRedux & {
  roles: string[],
  else?: ReactElement
}

const RenderForRole = ({ else: ElseComponent, roles, user, children }: React.PropsWithChildren<AuthenticatedRouteProps>) => {
  const hasPermission = user && user.roles && user.roles.some(r => roles.includes(r));

  return hasPermission ? <>{children}</> : ElseComponent ? ElseComponent : null;
}

export const isAuthenticated = () => {
  const loggedIn = store.getState().auth.loggedIn;
  return loggedIn;
}

export const isInRole = (roles: string[]) => {
  const user = store.getState().auth.user;
  
  if(!user) return false;
  const usrRoles = user.roles ? typeof user.roles === 'string' ? [user.roles] : user.roles : [];
  return usrRoles.some(r => roles.includes(r));
}

export const hasModule = (name: string) => {
  const user = store.getState().auth.user;
  
  if(!user) return false;

  const quarterEnabled = user.quarter_enabled || user.quarter_enabled === null || user.quarter_enabled === undefined || isInRole(['superadmin']);
  const clioEnabled = user.clio_enabled || isInRole(['superadmin']);

  const userPerm = !user.modules || user.modules.indexOf(name.toLowerCase()) > -1;

  if(name === 'quarter' && quarterEnabled && userPerm) return true;
  else if(name === 'clio' && clioEnabled && userPerm) return true;

  return false;
}


export default connector(RenderForRole);
